const isSidebarOpenMixin = {
  computed: {
    isSidebarOpen() {
      return !!this.$route.params.blockId
    },
  },
}

export default isSidebarOpenMixin
